import axios from "axios"
import config from "../config"
import { PAYMENT_VERIFY_TIMEOUT_MS } from "../components/Scheme/constants"

const { apiServerUrl } = config

const schemeApi = axios.create({
  baseURL: `${apiServerUrl}/pwa/scheme`,
})

const getAuthConfig = (token, business, extraConfig = {}) => ({
  ...extraConfig,
  ...(business ? { params: { business } } : {}),
  headers: {
    Authorization: `Bearer ${token}`,
    ...extraConfig.headers,
  },
})

export const getSchemeMasters = ({ token, business }) =>
  schemeApi
    .get("/masters", getAuthConfig(token, business))
    .then((response) => response.data)

export const getSchemeSubscriptions = ({ token, business }) =>
  schemeApi
    .get("/subscriptions", getAuthConfig(token, business))
    .then((response) => response.data)

export const getSchemeSubscription = ({ token, business, schemeId }) =>
  schemeApi
    .get(`/subscriptions/${schemeId}`, getAuthConfig(token, business))
    .then((response) => response.data)

export const getSchemeStoreOptions = ({ token, business }) =>
  schemeApi
    .get("/store-options", getAuthConfig(token, business))
    .then((response) => response.data)

export const createSchemeSubscription = ({
  token,
  business,
  schemeMasterId,
  monthlyAmount,
  tenantStoreId,
}) =>
  schemeApi
    .post(
      "/subscriptions",
      { schemeMasterId, monthlyAmount, tenantStoreId },
      getAuthConfig(token, business)
    )
    .then((response) => response.data)

export const createSchemePayment = ({ token, business, schemeId }) =>
  schemeApi
    .post(
      `/subscriptions/${schemeId}/payments`,
      null,
      getAuthConfig(token, business)
    )
    .then((response) => response.data)

export const verifySchemePayment = ({
  token,
  business,
  razorpayOrderId,
  razorpayPaymentId,
  razorpaySignature,
}) =>
  schemeApi
    .post(
      "/payments/verify",
      { razorpayOrderId, razorpayPaymentId, razorpaySignature },
      getAuthConfig(token, business, { timeout: PAYMENT_VERIFY_TIMEOUT_MS })
    )
    .then((response) => response.data)
